import React from 'react';
import { Link } from 'react-router-dom';
import questionsData from '../questions.json';

function HomePage() {
  const steps = [
    { number: 1, text: 'Start een oefentest met 30 willekeurige vragen' },
    { number: 2, text: 'Beantwoord elke vraag en krijg direct feedback' },
    { number: 3, text: 'Bekijk je eindscore en leer van je fouten' },
    { number: 4, text: 'Herhaal tot je klaar bent voor het echte examen' },
  ];

  return (
    <div className="animate-fade-in">
      {/* Hero Section */}
      <header className="mb-6">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-ink leading-snug mb-2">
          Sportschutterslicentie Examen
        </h1>
        <p className="font-display italic text-lg text-ink-light">
          Bereid je voor op het theoretische examen
        </p>
      </header>

      {/* Question Bank Info */}
      <div className="border-l-4 border-accent pl-4 mb-6">
        <p className="font-body text-ink-light">
          <span className="font-semibold text-ink">{questionsData.questions.length}</span> officiele examenvragen beschikbaar in onze vragenbank
        </p>
      </div>

      {/* How It Works Section */}
      <section className="mb-6">
        <h2 className="font-display text-xl font-semibold text-ink mb-3">
          Hoe het werkt
        </h2>
        <ol className="space-y-3">
          {steps.map((step) => (
            <li key={step.number} className="flex items-start gap-3">
              <span className="font-display font-semibold text-accent text-lg leading-tight">
                {step.number}.
              </span>
              <span className="font-body text-ink-light leading-relaxed">
                {step.text}
              </span>
            </li>
          ))}
        </ol>
      </section>

      {/* CTA Button */}
      <Link to="/test">
        <button
          className="w-full bg-accent hover:bg-accent-dark text-white font-body font-semibold py-3 px-8 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-paper"
          onClick={() => {
            window.gtag?.('event', 'start_button_click');
          }}
        >
          Start Oefentest
        </button>
      </Link>

      {/* Disclaimer */}
      <footer className="mt-6 pt-4 border-t border-border">
        <p className="font-body text-sm text-ink-muted">
          Disclaimer: Alleen voor studiedoeleinden. Raadpleeg officiele bronnen voor actuele exameneisen.
        </p>
      </footer>
    </div>
  );
}

export default HomePage;
